import { CampaignAdGroupAudienceSource } from '../types/Campaign';

const CampaignAdGroupAudienceSourceUtils = {
    toDspAudienceSourceIds: (targets: CampaignAdGroupAudienceSource[]): string[] => {
        return targets?.map((target: CampaignAdGroupAudienceSource) => target.dspAudienceId) || [];
    },
};

export default CampaignAdGroupAudienceSourceUtils;
